import { getOpenUrlInDesktopAppLink } from '../utils';

let lastOpened = '';

interface OpenAppProps {
  urlToOpen?: string | null;
  mode?: 'auth' | 'open-doc'; // default to 'auth'
}
export const OpenInAppPage = ({
  urlToOpen,
  mode = 'auth',
}: OpenAppProps) => {
  // default to open the current page in desktop app
  urlToOpen ??= getOpenUrlInDesktopAppLink(window.location.href, true);

  if (urlToOpen && lastOpened !== urlToOpen) {
    lastOpened = urlToOpen;
    location.href = urlToOpen;
  }

  if (!urlToOpen) {
    return null;
  }

  return null;
};
